import { ReactNode } from 'react';

import { Avatar } from '@components/avatar';
import { Card } from '@components/card';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

export type UserCardProps = {
  name: string;
  picture: string;
  email: string;
  role: 'superadmin' | 'admin' | 'recruiter' | 'limited' | 'user';
  departments?: string[];
  actions?: ReactNode;
};

export const UserCard = ({ name, picture, email, role, departments, actions }: UserCardProps) => {
  const { t } = useScopedTranslate(locale);
  return (
    <Card spaceX={4} spaceY={2}>
      <Stack orientation="horizontal" align="center" justify="space-between">
        <Stack orientation="horizontal" align="center" space={4}>
          <Avatar name={name} src={picture} size="md" />
          <div>
            <Text font="semibold14" text={name} />
            <Text font="regular14" text={email} />
            <Stack orientation="horizontal">
              <Text font="regular14" text={t(role)} />
              {departments && departments.length > 0 && (
                <>
                  <Text font="regular14" text=" • " />
                  <Text font="regular14" text={departments.join(', ')} />
                </>
              )}
            </Stack>
          </div>
        </Stack>
        <Stack space={4} orientation="horizontal" align="center">
          {actions}
        </Stack>
      </Stack>
    </Card>
  );
};

const locale = {
  en: {
    superadmin: 'Super-admin',
    admin: 'Admin',
    recruiter: 'Recruiter',
    limited: 'Limited team member',
    user: 'Employee',
  },
  is: {
    superadmin: 'Ofur-notandi',
    admin: 'Stjórnandi',
    limited: 'Takmarkaður notandi',
    recruiter: 'Ráðningarstjóri',
    user: 'Almennur starfsmaður',
  },
};
